import { render, staticRenderFns } from "./EditSaleDialog.vue?vue&type=template&id=47cb497d&scoped=true"
import script from "./EditSaleDialog.vue?vue&type=script&lang=js"
export * from "./EditSaleDialog.vue?vue&type=script&lang=js"
import style0 from "./EditSaleDialog.vue?vue&type=style&index=0&id=47cb497d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cb497d",
  null
  
)

export default component.exports